import { stringify } from "uuid";
import { handleErrors } from "../util/api-utils";

export function getAgentAccess(success) {
    fetch("api/IaConfiguration/RetrieveAgentAccess", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(success)
        .catch(console.error);
}

export function getAgentAccessSalesLeader(success, substituteAgentInfo = null) {
    fetch("api/IaConfiguration/RetrieveAgentAccessSalesLeader", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: substituteAgentInfo ? JSON.stringify(substituteAgentInfo) : null
    })
        .then(handleErrors)
        .then(success)
        .catch(console.error);
}